
CheckoutV2.Payment.CreditCard = function(checkout, payment, extra, isReview) {
	var creditcard = this;

	this.label = 'Credit Card';
	//this.noDisplayCombo = ['paypal']; // don't even display the add-multi option
	this.$error = false;
	this.$errorMsg = false;
	this.addError = false;

	this.fieldToSelector = {
		'cardType': '.js-credit-card .js-card-type',
		'cardNum': '.js-credit-card .js-card-number',
		'expMonth': '.js-credit-card .js-expiry-month',
		'expYear': '.js-credit-card .js-expiry-year',
		'cvc': '.js-credit-card .js-security-code',
		//'storeOnAccountWrap' : '.credit-card-store-wrap',
		'storeOnAccount' : ''
	};
	
	this.billInfo = {
		'firstname': '',
		'lastname': '',
		'address1': '',
		'address2': '',
		'city': '',
		'country': '',
		'zip': '',
		'state': '',
	};

    creditcard.validationMap = {
        'js-card-number': function() {},
        'js-expiry-month': function() {},
        'js-expiry-year': function() {},
        'js-security-code': function() {}
    };

	this.$wrap = false;

    this.buildReview = function() {
		var card = creditcard;
		var data = {
					method: 'creditcard',
					method_name: card.label,
					card_type: card.getType( card.$cardNum.val() ).type,
					card_last_four: card.$cardNum.val().slice(-4),
					card_expire_month: ((card.$expMonth.val() + '').length == 1 ? '0' : '') + card.$expMonth.val(),
					card_expire_year: (card.$expYear.val() + '').slice(-2),
					first_name: card.billInfo.firstname,
					last_name: card.billInfo.lastname,
					address: card.billInfo.address1 + ' ' + card.billInfo.address2,
					city: card.billInfo.city,
					state: card.billInfo.state,
					zip: card.billInfo.zip,
					payment_amount: checkout.payment.getMethodAmt( card ),
				};
		// var html = Jemplate.process('includes/partials/payment/review/method.html', data );
		return data;
    };

	this.init = function() {
		//if (checkout.config.isEndeca) {
		//	this.$addAnotherMenu.show();
		//	this.$addAnotherMenuSelect.children('select option[value=paypal]').show();
		//}

		if (creditcard.getContainer().children().length == 6) {
			creditcard.addError = 'Maximum of 6 Credit Cards Allowed';
			return;
		}

		creditcard.$wrap = $($.parseHTML(Jemplate.process('includes/partials/payment/creditCard.html')));
		
		$.each(creditcard.fieldToSelector, function(field, selector) {
			if (field == 'storeOnAccount') {
				creditcard['$'+field] = 1;
			} else {
				creditcard['$'+field] = creditcard.$wrap.find(selector);
			}
		});

		//var $cardHelpButtons = creditcard.$wrap.find('[rel=popover]');

		//if (checkout.config.isEndeca) {
		//	/* Shows, places and adds content to credit card help popovers in conjunction with #payment-content-wrapper .popover commands in style-2016927.css and bootstrap in an unclear manner. */
		//	$cardHelpButtons.popover({
		//		'html': true,
		//		'trigger': 'manual',
		//		'placement': 'right',
		//		'content': function(){return '<img src="'+$(this).data('img') + '" />';}
		//	}).on('click', function(e) {
		//		e.stopPropagation();
		//		var left = $(this).position().left;
		//		var width = $(this).outerWidth();
		//		var popoverPosition = left + width + 15;
		//		$('.popover').css('display','none');
		//		$(this).siblings('.popover').css('position','absolute');
		//		$(this).popover('show');
		//	});
		//
		//	$(document).on('click', function(e) {
		//		$('.popover').css('display','none');
		//	});
		//} else {
		//	$cardHelpButtons
		//		.popover({
		//			'html': true,
		//			'trigger': 'click',
		//			'placement': 'right',
		//			'content': function(){return '<img src="'+$(this).data('img') + '" />';}
		//		});
		//
		//	$cardHelpButtons.each(function(i, button) {
		//		$(button).data(checkout.config.bsPopoverData).tip()
		//			.find('.popover-title')
		//			.hide()
		//	});
		//}

		creditcard.listen();
	};

	this.listen = function() {
		creditcard.$error = creditcard.$wrap.find('.credit-card-alert');
		creditcard.$errorMsg = creditcard.$error.find('.msg-text');
		//creditcard.$wrap.find('.select-cardtype').change(function() {
		//	creditcard.changeCardType($(this));
		//});

        $( 'body' ).change( function( e ) {
            var $target = $( e.target );

            $.each( creditcard.validationMap, function( targetClass, action ) {
                if( $target.hasClass( targetClass ) ) {
					var errorsMap = [];
					if(targetClass === 'js-card-number') {
						// check credit card field for errors
                        errorsMap.push(creditcard.validateField( $target ));
                        if(errorsMap && errorsMap.length > 0 ) {
                            creditcard.fieldError( errorsMap[0].field, errorsMap[0].hasError );
						}
					} else if (targetClass === 'js-expiry-month' || targetClass === 'js-expiry-year' || targetClass === 'js-security-code') {
						// check all 3 fields for errors
                        errorsMap.push(creditcard.validateField( creditcard.$wrap.find('.js-expiry-month') ));
                        errorsMap.push(creditcard.validateField( creditcard.$wrap.find('.js-expiry-year') ));
                        errorsMap.push(creditcard.validateField( creditcard.$wrap.find('.js-security-code') ));

                        var hasMonthError = errorsMap.filter(function(e) { if(e.field === 'expireMonth') { return (e.hasError === true); } }).length;
                        var hasYearError = errorsMap.filter(function(e) { if(e.field === 'expireYear') { return (e.hasError === true); } }).length;
                        var hasCvvError = errorsMap.filter(function(e) { if(e.field === 'cvv') { return (e.hasError === true); } }).length;

						var errors = errorsMap.filter(function(value, index) {
						   if (errorsMap[index].hasError) {
                               	return value.field;
							}
						});

						// clear all errors
                        var $validity = creditcard.$wrap.find( '.js-validation-multi' );
                        $validity.find( '.js-invalid' ).toggle( false );
                        // clear valid on new errors
						if(errors.length > 0) {
                            $validity.find( '.js-valid' ).toggle( false );
						}

						// determine which error message to show
						if(hasMonthError && hasYearError && hasCvvError) {
                            creditcard.fieldError( 'month-year-cvv', true );
						}
						else if (hasMonthError && hasCvvError) {
                            creditcard.fieldError( 'month-cvv', true );
						}
                        else if (hasMonthError && hasYearError) {
                            creditcard.fieldError( 'month-year', true );
                        }
                        else if (hasCvvError) {
                            creditcard.fieldError( 'cvv', true );
                        }
                        else if (hasYearError) {
                            creditcard.fieldError( 'expire-year', true );
                        }
                        else if (hasMonthError) {
                            creditcard.fieldError( 'expire-month', true );
                        } else if (errors.length === 0) {
                            creditcard.fieldError( 'month-year-cvv', false );
						}
					}

                    action( $target );
                    found = true;
                }
            } );
        } );
	};
	
	this.setCompactView = function() {		
		creditcard.$wrap.find('.compact-view .js-card-number-compact').text(creditcard.$cardNum.val().slice(-4));
		creditcard.$wrap.find('.compact-view .js-expiry-month-compact').text(creditcard.$expMonth.val());
		creditcard.$wrap.find('.compact-view .js-expiry-year-compact').text(creditcard.$expYear.val());
		
		creditcard.$wrap.find('.compact-view .card-address').data('content',
			creditcard.billInfo.firstname + " " + creditcard.billInfo.lastname + "<br/>" + 
			creditcard.billInfo.address1 + "<br/>" + creditcard.billInfo.city + ", " + creditcard.billInfo.state + " " + creditcard.billInfo.zip
		);
		creditcard.$wrap.find('.compact-view .card-address[data-toggle="popover"]').popover();
		
		var cardType = creditcard.getType(creditcard.$cardNum.val()) || {type: 'Generic', value: 'generic'};
		creditcard.$wrap.find('.compact-view .card-image img').attr('src', CDNpath + '/img/paymentMethods/' + cardType.type + '.png');
		
		creditcard.$wrap.find('.form-view').hide();
		
		if (checkout.session.get('storedPayments').length < 1) {
			creditcard.$wrap.find('.change-card').hide();
		}
		
		creditcard.$wrap.find('.compact-view').show();
	};
	
	this.setFormView = function() {
		creditcard.$wrap.find('.compact-view').hide();
		creditcard.$wrap.find('.form-view').show();		
	};
	
	this.isFormView = function() {
		return creditcard.$wrap.find('.form-view:visible').length;
	};
	
	this.getContainer = function() {
		if (!payment.creditCardWrap)
			payment.creditCardWrap = new CheckoutV2.Payment.CreditCardWrap(checkout, payment, isReview);

		return payment.creditCardWrap.$container;
	};

	this.afterRemoved = function() {
		/*
		if (!creditcard.getContainer().children().length) {
			payment.creditCardWrap.remove();
			payment.creditCardWrap = false;
		}
		*/
	};

	this.clearInput = function() {
		creditcard.$wrap.find('input').val('');
	};

	this.getData = function() {
		var cardNumber = creditcard.$cardNum.val().trim().replace(/\D/g, '');
		var cardType = creditcard.getType(cardNumber);
		return {
			'cardType': cardType.type ? cardType.type : '',
			'cardNum': cardNumber,
			'expMonth': creditcard.$expMonth.val().trim().replace(/\D/g, ''),
			'expYear': creditcard.$expYear.val().trim().replace(/\D/g, ''),
			'cvc': creditcard.$cvc.val().trim(),
			'storeOnAccount': 1,
			'firstname': creditcard.billInfo.firstname,
			'lastname': creditcard.billInfo.lastname,
			'address1': creditcard.billInfo.address1,
			'address2': creditcard.billInfo.address2,
			'city': creditcard.billInfo.city,
			'country': creditcard.billInfo.country,
			'zip': creditcard.billInfo.zip,
			'state': creditcard.billInfo.state,
		};
	};
	
	this.setData = function(data) {
		creditcard.$cardType.val(creditcard.getType(data.cardNum).type || '');
		creditcard.$cardNum.val(data.cardNum || '');
		creditcard.$expMonth.val(data.expMonth || '');
		creditcard.$expYear.val(data.expYear || '');
		creditcard.$cvc.val(data.cvc || '');
	};
	
	this.setBillInfoData = function(data) {
		creditcard.billInfo.firstname = data.firstname || '';
		creditcard.billInfo.lastname = data.lastname || '';
		creditcard.billInfo.address1 = data.address1 || '';
		creditcard.billInfo.address2 = data.address2 || '';
		creditcard.billInfo.city = data.city || '';
		creditcard.billInfo.country = data.country || '';
		creditcard.billInfo.zip = data.zip || '';
		creditcard.billInfo.state = data.state || '';
	};

	this.validate = function(booleanOnly) {
		var rtn = false,
			data = creditcard.getData(),
			cleanFields = ['cardNum', 'expMonth', 'expYear'];
			
		booleanOnly = (booleanOnly !== undefined) ? booleanOnly : false;

		// Cleanup the Int-Only Inputs from Pasting Non-Int Data
		$.each(cleanFields, function(i, field) {
			creditcard['$'+field].val(data[field] || '');
		});

		rtn = payment.validateCreditCard(data);
		if (!rtn.valid && rtn.errorMsg) {
			creditcard.$errorMsg.html(rtn.errorMsg);
			creditcard.$error.show();
		} else {
			creditcard.$errorMsg.html('');
			creditcard.$error.hide();
		}
		
		return booleanOnly ? rtn.valid : rtn;
	};

    creditcard.validateField = function( $field ) {
        var fieldName = $field.prop( 'name' );
        var minlength = $field.attr( 'minlength' );
        if( ! minlength ) {
            var required = $field.attr( 'required' );
            if( required ) minlength = 1;
            else           minlength = 0;
        }

        var value = '';
        if( $field.val() ) value = $field.val().trim();

        if( value.length < minlength ) {
            return {'field': fieldName, 'hasError': true};
        }
        else if( $field.attr( 'max' ) &&   Number( $field.attr( 'max' ) ) < Number( value ))
        {
            return {'field': fieldName, 'hasError': true};
        }
        else if( $field.attr( 'min' ) &&   Number( $field.attr( 'min' ) ) > Number( value ))
        {
            return {'field': fieldName, 'hasError': true};
        }

        return {'field': fieldName, 'hasError': false};
    };

    creditcard.fieldError = function( field, err ) {
        var target = '.js-validity-' + field;
        var $validity = creditcard.$wrap.find( target );
        $validity.show();
        $validity.find( '.js-valid'   ).toggle( ! err );
        $validity.find( '.js-invalid' ).toggle(   err );
    };
	
	this.afterShow = function() {
		checkout.billinfo.displayBillingAddress();
		checkout.billinfo.changeAddressListeners();
		
		$('.js-credit-card .js-what-is-this').popover({
			content: $('.js-popover-wrapper').html(),
			html: true,
			trigger: 'focus',
			placement: 'left',
			boundary: 'window',
			offset: "-30",
			title: payment.creditCardWhatIsThis().title,
			container: $('.js-credit-card .what-is-this')[0],
		});
		
		creditcard.$wrap.find('.js-card-number,.js-expiry-month,.js-expiry-year,.js-security-code').on('keyup', function(e) {
			checkout.restrictNumbers(e);
		});
		
		creditcard.$wrap.find('.js-change-credit-card').on('click', function(){
			var methodKey = $(this).parents('.payment-method').data('methodKey');
			var card_list = [];
			$.each(checkout.session.get('storedPayments'), function(i, card) {
				card_list.push({
					id: card.method.split('storedcreditcard-')[1],
					type: card.cardType,
					last_four: card.cardLast4,
					expire_month: ((card.expMonth + '').length == 1 ? '0' : '') + card.expMonth,
					expire_year: (card.expYear + '').slice(-2),
					first_name: card.firstName,
					last_name: card.lastName,
					address: card.address,
					city: card.city,
					state: card.state,
					zip: card.zip,
					billID: card.billID,
				});
			});
			$('#changeCreditCardModal .js-credit-card-list').html(
				Jemplate.process('includes/partials/payment/creditCardList.html', {
					current_card: -1,
					card_list: card_list,
					list_type: 'change',
				})
			);
			
			$('#changeCreditCardModal').modal('show');
			
			$('#changeCreditCardModal .js-credit-card-list .card-address[data-toggle="popover"]').popover();
			
			$('#changeCreditCardModal .js-add-credit-card').off('click');  // remove stored credit card listener, just in case
			$('#changeCreditCardModal .js-add-credit-card').on('click', function(){
				$('#addCreditCardModal .credit-card-alert .msg-text').html('');
				$('#addCreditCardModal .credit-card-alert').hide();
				$('#addCreditCardModal').modal('show');
				$('#addCreditCardModal .replaceMethodKey').val(methodKey);
			});
			
			$('#changeCreditCardModal .js-change-credit-card-btn').off('click');  // remove stored credit card listener, just in case
			$('#changeCreditCardModal .js-change-credit-card-btn').on('click', function(){
				var $selected = $('#changeCreditCardModal .js-credit-card-list input[type=radio]:checked');
				if ($selected && $selected.attr('id')) {
                    var previousPayment = payment.methods[ methodKey ];
                    var previousPaymentAmount = payment.getMethodAmt( previousPayment );
					payment.removeMethod(methodKey, false, true);

                    var newKey = "storedcreditcard-" + $selected.attr( "id" );
					payment.addMethod( newKey, previousPaymentAmount, true );
					$('#changeCreditCardModal').modal('hide');
				}
			});
		});
	};
	
	this.getType = function(cardNum) {
		var cardType = payform.parseCardType(cardNum);
		if (cardType) {
			return {
				type: cardType,
				value: $.camelCase('-' + cardType),
			}
		}
		/*
		var cardDetectMethods = [{
			name: "visa",
			regex: /^4/,
			value: "VISA"
		}, {
			name: "mastercard",
			regex: /^(5[1-5]|2(2(2[1-9][0-9]{2}|[3-9])|[3-6]|7([01]|20[0-9]{2})))/,
			value: "MC"
		}, {
			name: "amex",
			regex: /^3[47]/,
			value: "AMEX"
		}, {
			name: "discover",
			regex: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5])|64[4-9]|65)/,
			value: "DSC"
		}];
		for (var i = 0; i < cardDetectMethods.length; i++) {
			if (cardDetectMethods[i].regex.test(cardNum)) {
				var method = cardDetectMethods[i];
				return {
					type: method.name,
					value: method.value
				}
			}
		}
		*/
		return {};
	};

	this.init();
};

